const listeners = {};

const EventBus = {
  on(event, callback) {
    (listeners[event] = listeners[event] || []).push(callback);
  },
  off(event, callback) {
    if (!listeners[event]) return;
    if (!callback) {
      listeners[event] = [];
    } else {
      listeners[event] = listeners[event].filter((cb) => cb !== callback);
    }
  },
  emit(event, payload) {
    // Only call if cb is a function
    (listeners[event] || []).forEach((cb) => {
      if (typeof cb === "function") {
        cb(payload);
      }
    });
  },
  remove(event, callback) {
    this.off(event, callback);
  },
};

export default EventBus;
